export const SET_CREDENTIALS = 'CREDENTIALS/SET';
export const RESET_CREDENTIALS = 'CREDENTIALS/RESET';



// WEBPACK FOOTER //
// ./src/action_types/credentialActionTypes.ts